import useSWR from 'swr';

import { getProfile } from '@/api/user-profile';
import { useUserProfile } from '@/states/user-profile';

/**
 * Fetches the user profile from the API and sets it in the global state.
 */
export function useGetUserProfile() {
  const email = useUserProfile((state) => state.profile.email);
  const { data, isLoading, mutate } = useSWR(email, getProfile);

  return { loading: isLoading, refresh: mutate, profile: data };
}
